const order = { debug: 10, info: 20, warn: 30, error: 40 };
function emit(level, label, message, meta) {
    const prefix = '%c[' + label + ']';
    const style = level === 'error' ? 'color:#e11' : level === 'warn' ? 'color:#b90' : 'color:#888';
    if (level === 'error')
        console.error(prefix, style, message, meta ?? '');
    else if (level === 'warn')
        console.warn(prefix, style, message, meta ?? '');
    else
        console.log(prefix, style, message, meta ?? '');
}
export function getClientLogger(label = 'opus-web', level = 'debug') {
    const min = order[level];
    return {
        debug: (m, meta) => {
            if (order.debug >= min)
                emit('debug', label, m, meta);
        },
        info: (m, meta) => {
            if (order.info >= min)
                emit('info', label, m, meta);
        },
        warn: (m, meta) => {
            if (order.warn >= min)
                emit('warn', label, m, meta);
        },
        error: (m, meta) => emit('error', label, m, meta),
    };
}
/** Global unhandled-error hook; idempotent. */
export function installGlobalErrorLogging(log) {
    const w = window;
    if (w.__opusErrorLogging)
        return;
    w.__opusErrorLogging = true;
    window.addEventListener('error', (e) => log.error('window error', { message: e.message, source: e.filename, line: e.lineno }));
    window.addEventListener('unhandledrejection', (e) => log.error('unhandled rejection', { reason: String(e.reason) }));
}
//# sourceMappingURL=client.js.map